import { render, staticRenderFns } from "./JobPreviewCompanyInfoSp.vue?vue&type=template&id=586b0d20&scoped=true"
import script from "./JobPreviewCompanyInfoSp.vue?vue&type=script&lang=js"
export * from "./JobPreviewCompanyInfoSp.vue?vue&type=script&lang=js"
import style0 from "./JobPreviewCompanyInfoSp.vue?vue&type=style&index=0&id=586b0d20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586b0d20",
  null
  
)

export default component.exports